import { TimelineProps, Timeline as AntTimeline } from 'antd';
import { StyledTimeline } from './styles';

const Timeline = (props: TimelineProps) => {
    return <StyledTimeline {...props} />;
};

Timeline.Item = AntTimeline.Item;

export default Timeline;
